import Vue from 'vue'
import createPersistedState from 'vuex-persistedstate'
export const ADULTTYPE = 'adult'
export const JUNIORTYPE = 'junior'

import { parseNumber, alert } from '../../lib/utils'
import { formatDate, parseDateTime, DateTime, Settings, time2Min} from '../../lib/dates'
Settings.defaultLocale = 'en-us'

import * as types from '../mutation-types/race'

import ProviderService from '../../services/provider'
import config from '../../lib/config'

export const raceType = 'race-reservations'
export const racePointType = 'races'
export const membershipType = 'memberships'
export const accessoriesType = 'accessories'

const {
  DEFAULT_BOOKING_BUFFER: buffer = 0,
  TIMEZONE: timezone,
  RACE_TIME_GAP_MINUTES  = 10,
  clubspeed: {
    taxes,
    products: {race_reservations = [], races = [], memberships = [], upsells = [], headsock = null},
    settings = {},
  },
  RACE_TEST_DEFAULTS = {},
  RACES_SETTINGS = {}
} = config


// set this true to namespace all getters, mutations, actions etc.
const namespaced = true
export const namespace = 'race'

const min = Math.min
const max = Math.max
const dayBreakTime = '18:00' || config.DAY_SPLIT
const holdDefault = {
  onlineBookingReservationsId: null,
  expiresAt: null,
  quantity: null,
  checkId: null,
  customersId: null,
  sessionId: '',
  createdAt: null,
  onlineBookingReservationStatusId: null,
}

const racerDetailsItem = {
            racerName: '',
            type: ADULTTYPE,
            quantity: '',
            membership: '',
            headsock: null,
            guest: false,
          }
// state
const state = {
  editItem: null,
  cartItems: {},
  settings: {
    maxKarts: 12,
    groups: {
      [raceType]: {
        groupTitle: 'Race Reservations',
        editable: true,
        deletable: true,
        children: ['races', 'memberships', 'accessories'],
      },
      races: {
        groupTitle: 'Points',
        editable: false,
        deletable: false,
        attributes: {
          skipCartCount: true
        }
      },
      memberships: {
        groupTitle: 'Memberships',
        description: 'Annual',
        editable: false,
        deletable: false,
        attributes: {
          skipCartCount: true
        }
      },
      accessories: {
        groupTitle: 'Accessories',
        description: '',
        editable: false,
        deletable: false,
        attributes: {
          skipCartCount: true
        }
      }
    },
    [raceType]: race_reservations,
    races: races,
    memberships: memberships,
    upsells,
    headsock,
    accessories: {[headsock.id]: headsock, ...upsells}
  },
  allowSlotGrouping: false, // use this to group at front end by hour
  form: Object.assign({},
    {
        cartId: null,
        termsAgreed: 'no',
        raceType: 'race',
        racerDetails: [_.clone(racerDetailsItem)],
        racerRacesMatrix: [],
        racerRacesMatrixGrouped: [],
        numberOfAdults: 0,
        numberOfMemberAdults: 0,
        numberOfJuniors: 0,
        numberOfAdultRaces: 0,
        numberOfJuniorRaces: 0,
        numberOfTitaniumMembers: 0,
        numberOfTitaniumRaces: 0,
        numberOfTitaniumGuests: 0,
        numberOfTitaniumGuestRaces: 0,
        numberOfHeadsocks: 0,
        numberOfMembers: 0,
        membersRegistered: 0,
        selectedDate: null,// DateTime.local().toISODate(),
        selectedSlots: {}, // time, type, karts, selected, racers, tMembers
        // raceSeparately: 'no',
        dayRaceSeparately: 'no',
        eveningRaceSeparately: 'no',
        allowRaceSeparately: true,
        holdStartsAt: null,
        holdEndsAt: null,
        usePackages: true,
        hasGroupedSlots: true, // use this to book grouped slots at backend
        timezone,
        buffer,
    }
    , RACE_TEST_DEFAULTS)
    ,
  productAccessories: {},
  retrievedSlots: {},
  retrievedAvailability: {},
  fetchingTimeslots: false,
  wasCarted: false,
  isHydrating: false,
}

const helpers = {
  prepareAccessoriesCartItems(items, parentId, settings, state, getters) {
    const type = 'accessories'

    let cartItems = _.reduce(items, (items, aItem, aId) => {

      const {count, product} = aItem
      const {product_id, tax_amount, title, price} = product

      if (!count) {
        return items
      }

      const total = price * count
      const editable = false
      const deletable = true
      const tax = tax_amount * count
      const date = DateTime.fromISO(getters.input('selectedDate')).toISODate()
      const id = aItem.cartId || date + '_' + product_id

      const options = {
        id,
        total,
        count,
        tax,
        parentId
      }
      const attributes = {
        id,
        total,
        count,
        tax,
        product,
        parentId,
        localItem: aItem
      }

      const item = {
        id,
        title,
        type,
        total,
        payload: {
          product_id,
          count,
          options
        },
        editable,
        deletable,
        attributes
      }
      items[aId] = item
      return items
    }, {})

    return cartItems
  },
  prepareUniversalCartItems(items, settings, state, getters) {
    let groupParentId = null
    const itemTemplate = settings.groups
    const date = DateTime.fromISO(getters.input('selectedDate')).toISODate()
    if (!date) {
      return {}
    }
    const cartItems = _.reduce(items, (items, product) => {
      const {product_id, key, type, meta, amount: total, tax_amount, title, rate, quantity: count} = product
      if (!count) {
        return items
      }
      const cartItemTemplate = itemTemplate[type]
      const isReservation = type === raceType
      const isRacePoint = type === racePointType
      const isMembership = type === membershipType

      const id = date + '_' + product_id + '_' + key

      const tax = tax_amount * count

      const {form} = state
      const options = {
        id,
        total,
        count,
        tax,
      }

      const attributes = {
        product,
        meta
      }

      if (isReservation) {
        options.raceType = form.raceType
        attributes.raceType = form.raceType
        options.form = form
        attributes.form = form
      }

      const item = _.merge({}, cartItemTemplate, {
        id,
        title,
        type,
        total,
        payload: {
          product_id,
          count,
          options
        },
        attributes
      })
      items[id] = item
      return items
    }, {})

    const children = _.keys(_.pickBy(cartItems, item => item.type !== raceType))
    const optionsChildren = _.keys(_.pickBy(cartItems, item => item.type !== raceType && item.type !== 'giftcard'))

    const tierTotal = _.reduce(cartItems, (totals, item) => {
      if (item.type === 'races') {
        totals += ((1 * item.total || 0) || 0)
      }
      return totals
    }, 0)

    _.forOwn(cartItems || [], item => {
      if (item.type === raceType) {
        groupParentId = item.id
        item.attributes.tierTotal = tierTotal
        item.payload.options.tierTotal = tierTotal
        item.attributes.childItems = children
        item.payload.options.childItems = optionsChildren
      }
    })

    const accessories = JSON.parse(JSON.stringify(state.productAccessories || {}))
    _.forOwn(cartItems || [], (aItem, aId) => {
      if (aItem.type === accessoriesType) {
        // const productId = aItem.attributes.product.id
        // accessories[productId].cartId = aItem.id
        if (groupParentId) {
        }
      }
    })

    if (!_.isEmpty(accessories)) {
      if (groupParentId) {
        cartItems[groupParentId].attributes.accessories = accessories
        cartItems[groupParentId].payload.options.accessories = accessories
      }
    }

    return cartItems
  },
  groupCartItems(items, settings, state, getters) {
    const groups  = items.reduce((groupItems, item) => {
        const groupName =  item.type
        const {[groupName]:groupItem = {
            ...settings.groups[groupName],
            ...{id: groupName, type: groupName, rate: 0, amount: 0, quantity: 0, subItems: []},
          }} = groupItems

        groupItem.subItems.push(item)
        groupItem.amount += item.amount || 0
        groupItem.quantity += item.quantity || 0

        const {description = '', attributes:attr = {}} = groupItem
        attr.date = item.date
        groupItem.attributes = attr
        if (_.isFunction(description)) {
          groupItem.description = description()
        }

        groupItems[groupName] = groupItem

        return groupItems

    }, {})

    return groups
  },
  getCartItem(data, options, settings, state, getters) {

    return data.map(item => {
      const source = settings[item.type][item.key] || {}
      item.amount = source.rate * item.quantity
      item.points = source.p_points * item.quantity
      return Object.assign({}, source, item, options)

    })
  },
  getType(type) {
    const types = {
      [ADULTTYPE]: ADULTTYPE,
      [JUNIORTYPE]: JUNIORTYPE
    }
    const typeFound = /youth|junior/i.test(type) ? JUNIORTYPE: ADULTTYPE
    return types[typeFound]
  },
  getSubType(type) {
    const types = {
      'Adult Pole Qualifier': 'pole-qualifier',
    }
    return types[type] || ''
  },
  getMiniLabel(type) {
    const types = {
      'Adult Pole Qualifier': 'APQ',
    }
    return types[type] || helpers.getType(type)
  },
  slotTimeType(time) {
    if (time >= dayBreakTime) {
      return 'evening'
    }
    return 'day'
  },
  parseRetrievedTimeslots(data) {

    // const template = {
    //   "heatId": 479351,
    //   "heatDescription": "~Adult Race",
    //   "heatStartsAt": "2018-12-08T14:10:00.00",
    //   "heatSpotsTotalActual": 12,
    //   "heatSpotsAvailableCombined": 0,
    //   "heatSpotsAvailableOnline": 0,
    //   "heatTypeId": 6,
    //   "isPublic": true,
    //   "products": [{
    //     "onlineBookingsId": 56092,
    //     "price1": 20,
    //     "productDescription": "1 Kart Race (web)",
    //     "productsId": 3199,
    //     "productSpotsAvailableOnline": 0,
    //     "productSpotsTotal": 12,
    //     "productType": "ReservationItem"
    //   }]
    // }
    const timeslots = _.reduce(data, (slots, item) => {
      const {heatStartsAt, heatDescription, heatSpotsTotalActual, heatSpotsAvailableOnline} = item
      const date = DateTime.fromISO(heatStartsAt, {zone: timezone})
      // const currentDate = formatDate(date, 'd MMMM yyyy')
      const currentDate = formatDate(date, 'M/d/yyyy')
      const time = formatDate(date, 'h:mm a')
      const time24 = formatDate(date, 'HH:mm')
      const originalProduct = item.products[0] || {}
      const originalProductId = originalProduct.productsId
      const onlineBookingsId = originalProduct.onlineBookingsId

      const reservationProduct = race_reservations[originalProductId]
      if (!reservationProduct) {
        return slots
      }
      const product_id = reservationProduct.product_id

      item.originalProductId = originalProductId
      item.product_id = product_id

      const slot = {
        item: item,
        bookingId: onlineBookingsId,
        sectionType: helpers.slotTimeType(time24),
        id: item.heatStartsAt + '_' + product_id,
        maxKarts: parseInt(heatSpotsTotalActual),

        type: helpers.getType(heatDescription),
        subType: helpers.getSubType(heatDescription),
        miniLabel: helpers.getMiniLabel(heatDescription),
        dateValue: date.valueOf(),
        datetime: date,
        date: currentDate,
        time: time,
        timeAsNumber: time2Min(time),

        karts: parseInt(heatSpotsAvailableOnline),
        racers: 0,
        selected: false,

        hold: _.merge({}, holdDefault,  {onlineBookingsId}),
        adjacentDisable: false,
        tMembers: 0
      }
      slots[time] = slot
      return slots

    }, {})

    const items = Object.values(timeslots || {})
    items.forEach((item, index) => {
      item.prevTime = (items[index -1] || {}).time
      item.prevType = (items[index -1] || {}).type
      item.nextTime = (items[index + 1] || {}).time
      item.nextType = (items[index + 1] || {}).type
    })
    return timeslots
  },
  packageRacer({quantity, type, membership, guest}, {packages}) {
    const races = {};
    if (/titanium/.test(membership)) {
      races.titanium = quantity
    } else {
      _.forOwn(packages, raceName => {
        const count = parseInt(quantity / raceName)
        quantity = quantity % raceName
        if (count) {
          races[raceName] = count
        }
      })
    }
    return races
  },
  mapTitaniumGuests(racerPacks, racers, packages) {

    const titaniumMembers = _.reduce(racerPacks, (members, racer, index) => {
      _.forOwn(racer, (count, pack) => {
        if (count && /titanium/.test(pack)) {
          members.push(count)
        }
      })
      return members
    }, [])

    _.forOwn(racers, (racer, index) => {
      if (racer.guest && racer.quantity) {
        let count = racer.quantity
        let found = -1
        do {
          found = _.indexOf(titaniumMembers, count)
          if (found >= 0) {
            titaniumMembers.splice(found, 1)
            racerPacks[index] = {
              titanium: count
            }
            const countDiff = racer.quantity - count

            if (countDiff) {
              const racerWithRemainingRaces = Object.assign(_.cloneDeep(racer), {quantity: countDiff})
              const guestPackages = helpers.packageRacer(racerWithRemainingRaces, {packages})
              racerPacks[index] = Object.assign(racerPacks[index], guestPackages)
            }
          }
          --count
        } while(count && found < 0)
      }
    })

    return racerPacks
  },
  orderObjectBy(obj, iteratees, orders) {
    const ordered = {}
    const sortedArray = _.orderBy(obj, iteratees, orders)
    _.forOwn(sortedArray, (item, index) => {
      const key  = _.findKey(obj, o => o === item);
      ordered[key] = item;
    })
    return ordered
  }

}

// mutations
const mutations = {
  [types.SET_EDIT_ITEM](state, item) {
    Vue.set(state, 'editItem', item)
  },
  [types.SET_CARTED](state) {
    Vue.set(state, 'wasCarted', true)
  },
  [types.SET_INPUT](state, items) {
    _.forOwn(items, (value, key) => {
      Vue.set(state.form, key, value)
    })
  },
  [types.SET_TIMESLOT](state, item) {
    if (_.isEmpty(state.form.selectedSlots)) {
      Vue.set(state.form, 'selectedSlots', {})
    }
    Vue.set(state.form.selectedSlots, item.time, item)
    const slots = helpers.orderObjectBy(state.form.selectedSlots, ['dateValue'], ['asc']);
    Vue.set(state.form, 'selectedSlots', slots)
  },
  [types.UNSET_TIMESLOT](state, item) {
    if (_.isEmpty(state.form.selectedSlots)) {
      Vue.set(state.form, 'selectedSlots', {})
    } else {
      Vue.delete(state.form.selectedSlots, item.time)
      const slots = helpers.orderObjectBy(state.form.selectedSlots, ['dateValue'], ['asc']);
      Vue.set(state.form, 'selectedSlots', slots)
    }
  },
  [types.SET_TIMESLOT_DATA](state, {time, key, value}) {
    if (_.isEmpty(state.form.selectedSlots)) {
      Vue.set(state.form, 'selectedSlots', {})
    }
    const slot = state.form.selectedSlots[time]
    if (slot) {
      Vue.set(state.form.selectedSlots[time], key, value)
    }
    const slots = helpers.orderObjectBy(state.form.selectedSlots, ['dateValue'], ['asc']);
    Vue.set(state.form, 'selectedSlots', slots)
  },
  [types.RETRIEVING_TIMESLOTS](state, payload) {
    Vue.set(state, 'fetchingTimeslots', payload)
  },
  [types.SET_RETRIEVED_TIMESLOTS](state, payload) {
    Vue.set(state, 'retrievedSlots', payload)
  },
  [types.SET_RETRIEVED_TIMESLOT_DATA](state, {time, key, value}) {
    const slot = state.retrievedSlots[time]
    if (slot) {
      Vue.set(state.retrievedSlots[time], key, value)
    }
  },
  [types.SET_RETRIEVED_TIMESLOT_DATA_ITEMS](state, items) {
    _.forOwn(items, ({key, value, time}) => {
      const slot = state.retrievedSlots[time]
      if (slot) {
        Vue.set(state.retrievedSlots[time], key, value)
       }
      }
    )
  },
  [types.SET_RETRIEVED_AVAILABILITY](state, payload) {
    Vue.set(state, 'retrievedAvailability', payload)
  },
  [types.CLEAN_TIMESLOTS](state, payload) {
    Vue.set(state.form, 'selectedSlots', {})
  },

  [types.SET_LOCAL_CART_ITEM](state, item) {
    Vue.set(state.cartItems, item.date || item.cartId, item)
  },
  [types.UNSET_LOCAL_CART_ITEM](state, item) {
    Vue.delete(state.cartItems, item.date || item.cartId)
  },
  [types.CLEAR_LOCAL_CART_ITEMS](state) {
    Vue.set(state, 'cartItems', {})
  },
  [types.IS_HYDRATING_DATA](state, isHydrating) {
    state.isHydrating = isHydrating !== false
  },
  [types.SET_PRODUCT_ACCESSORIES](state, payload) {
    Vue.set(state, 'productAccessories', payload)
  },
  [types.ADD_RACER_DETAILS_ITEM](state, data) {
    state.form.racerDetails.push(data || _.clone(racerDetailsItem))
  },
  [types.UPDATE_RACER_DETAILS_ITEM](state, {index, racer}) {
    Vue.set(state.form.racerDetails, index, racer)
  },
  [types.DELETE_RACER_DETAILS_ITEM](state, index) {
    Vue.delete(state.form.racerDetails, index)
  },
}

const actions = {
  allowToRaceSeparately({commit}, payload) {
    commit(types.ALLOW_RACE_SEPARATELY, payload)
  },
  setRaceTypes({commit}, payload) {
    commit(types.SET_RACE_TYPES, payload)
  },
  setRaceEditItem({commit}, payload) {
    commit(types.SET_EDIT_ITEM, payload)
  },
  setRaceInEditMode({commit}) {
    commit(types.SET_CARTED)
  },
  setInput({commit}, payload) {
    commit(types.SET_INPUT, payload)
  },
  async retrieveTimeslots({commit, dispatch, getters}, date) {
    commit(types.RETRIEVING_TIMESLOTS, true)
    let data = {}
    try {
      data = await ProviderService.getBookingAvailability(date)
    } catch (e) {
      alert('Unable to retrieve booking slots. Please try again!', {classes: 'text-danger'})
      commit(types.RETRIEVING_TIMESLOTS, false)
      return {}
    }

    commit(types.SET_RETRIEVED_AVAILABILITY, _.mapKeys(data, ({heatStartsAt}) => heatStartsAt))
    const timeslots = helpers.parseRetrievedTimeslots(data)
    dispatch('setRetrievedTimeslots', timeslots)
    commit(types.RETRIEVING_TIMESLOTS, false)
    return timeslots
  },
  setRetrievedTimeslots({commit}, payload) {
    commit(types.SET_RETRIEVED_TIMESLOTS, payload)
  },
  setRetrievedTimeslotDataItems({commit}, payload) {
    commit(types.SET_RETRIEVED_TIMESLOT_DATA_ITEMS, payload)
  },
  setRetrievedTimeslotData({commit}, payload) {
    commit(types.SET_RETRIEVED_TIMESLOT_DATA, payload)
  },
  cleanRetrievedTimeslots({dispatch}) {
    dispatch('setRetrievedTimeslots', {})
  },

  setTimeslot({commit, dispatch, getters}, payload) {

    if (!getters.isHydratingData && getters.input('allowRaceSeparately') === false) {
        dispatch('cleanTimeslots')
    }

    const parentTime = payload.time
    let slot = getters.getSelectedTimeslot(parentTime)
    if (!slot) {
      commit(types.SET_TIMESLOT, getters.retrievedTimeslot(parentTime))
      slot = getters.getSelectedTimeslot(parentTime)
    }
    // selected timestamp, payload.selected is here used during hydrating
    const now = !payload.selected || _.isBoolean(payload.selected) ? (new Date()).valueOf() : payload.selected
    dispatch('setTimeslotData', {time: parentTime, key: 'selected', value: now})

      // when force setting of races is required
    const racers = payload.racers || null
    if (!_.isNull(racers)) {
      dispatch('setTimeslotData', {time: parentTime, key: 'racers', value: racers})
    }

    // disable all adjacent slots irrespective of types
    // disable adjacent if less equals than 10 minutes
    const disableThreshold = RACE_TIME_GAP_MINUTES || 10
    const thisTime = DateTime.fromFormat(parentTime, 'h:mm a')
    const slotType = slot.type

    const slotPrevTime = slot.prevTime
    if (slotPrevTime) {
      const prevSlot = getters.retrievedTimeslot(slotPrevTime)
      const prevType = prevSlot.type
      if (prevType === slotType) {
        const prevTime = DateTime.fromFormat(slotPrevTime, 'h:mm a')
        const prevDiff = Math.abs((thisTime.diff(prevTime, 'minutes').minutes) || 0)
        if (prevDiff <= disableThreshold) {
          dispatch('setRetrievedTimeslotData', {time: slotPrevTime, key: 'adjacentDisable', value: true})
        }
      }
    }

    const slotNextTime = slot.nextTime
    if (slotNextTime) {
      const nextSlot = getters.retrievedTimeslot(slotNextTime)
      const nextType = nextSlot.type
      if (nextType === slotType) {
        const nextTime = DateTime.fromFormat(slotNextTime, 'h:mm a')
        const nextDiff = Math.abs((nextTime.diff(thisTime, 'minutes').minutes) || 0)
        if (nextDiff <= disableThreshold) {
          dispatch('setRetrievedTimeslotData', {time: slotNextTime, key: 'adjacentDisable', value: true})
        }
      }
    }

    const holds = payload.holds || null
    if (holds) {
      _.forOwn(holds , (hold, time) => {
        // console.log({hold, time})
        dispatch('setTimeslotData', {time: time, key: 'hold', value: hold})
      })
    }

  },
  setTimeslotData({commit}, payload) {
    commit(types.SET_TIMESLOT_DATA, payload)
  },
  cleanTimeslots({commit, dispatch, getters}) {
    _.forOwn(getters.selectedAllTimeslots, item => {
      dispatch('removeTimeslot', item)
    })
    // commit(types.CLEAN_TIMESLOTS)
  },
  removeTimeslot({commit, dispatch, getters}, payload) {
    //
    if (!payload) {
      return
    }
    const parentTime = payload.time

    dispatch('setTimeslotData', {time: parentTime, key: 'selected', value: false})
    dispatch('setTimeslotData', {time: parentTime, key: 'racers', value: 0})
    dispatch('setTimeslotData', {time: parentTime, key: 'tMembers', value: 0})

    const parent = getters.selectedAllTimeslots[parentTime]
    const holdId = _.get(parent || {}, 'hold.onlineBookingReservationsId')
    if (holdId) {
      let holdIds = [holdId];
      dispatch('setTimeslotData', {time: parentTime, key: 'hold', value: _.merge({}, parent.hold, holdDefault)})

      if (holdIds.length) {
        ProviderService.unhold(holdIds)
      }
    }

    // disable all adjacent slots irrespective of types
    let prevSlot, prev2Slot, nextSlot, next2Slot
    const disableThreshold = RACE_TIME_GAP_MINUTES || 10
    const slotType = parent.type

    if (parent.prevTime) {
      prevSlot = getters.retrievedTimeslot(parent.prevTime)
      if (prevSlot && prevSlot.type === slotType) {
        let prevEnable = true
        prev2Slot = getters.retrievedTimeslot(prevSlot.prevTime)
        if (prev2Slot && prev2Slot.selected && prev2Slot.type === slotType) {
          const prevTime = DateTime.fromFormat(prevSlot.time, 'h:mm a')
          const prev2Time = DateTime.fromFormat(prev2Slot.time, 'h:mm a')
          const prevDiff = Math.abs((prevTime.diff(prev2Time, 'minutes').minutes) || 0)
          if (prevDiff <= disableThreshold) {
            prevEnable = false
          }
        }
        if (prevEnable) {
          dispatch('setRetrievedTimeslotData', {time: parent.prevTime, key: 'adjacentDisable', value: false})
        }
      }
    }

    if (parent.nextTime) {
      nextSlot = getters.retrievedTimeslot(parent.nextTime)
      if (nextSlot && nextSlot.type === slotType) {
        let nextEnable = true
        next2Slot = getters.retrievedTimeslot(nextSlot.nextTime)
        if (next2Slot && next2Slot.selected && next2Slot.type === slotType) {
          const nextTime = DateTime.fromFormat(nextSlot.time, 'h:mm a')
          const next2Time = DateTime.fromFormat(next2Slot.time, 'h:mm a')
          const nextDiff = Math.abs((next2Time.diff(nextTime, 'minutes').minutes) || 0)
          if (nextDiff <= disableThreshold) {
            nextEnable = false
          }
        }
        if (nextEnable) {
          dispatch('setRetrievedTimeslotData', {time: parent.nextTime, key: 'adjacentDisable', value: false})
        }
      }
    }

    commit(types.UNSET_TIMESLOT, payload)
  },
  updateTimeslotSelection({dispatch}, payload) {
    if (payload.selected) {
      dispatch('setTimeslot', payload)
    } else {
      dispatch('removeTimeslot', payload)
    }
  },
  unsetSlottedMembers({dispatch, state, getters}) {
    _.forOwn(getters.selectedTimeslots, ({time}) => {
        dispatch('setTimeslotData', {time: time, key: 'tMembers', value: 0})
    })
  },
  unsetAllPlayers({dispatch, state, getters}) {
    dispatch('unsetSlottedMembers')
    _.forOwn(getters.selectedTimeslots, ({time}) => {
        dispatch('setTimeslotData', {time: time, key: 'racers', value: 0})
    })
  },
  setLocalCartItem({commit}, payload) {
    commit(types.SET_LOCAL_CART_ITEM, payload)
  },
  unsetLocalCartItem({commit}, payload) {
    commit(types.UNSET_LOCAL_CART_ITEM, payload)
  },
  clearLocalCart({commit}) {
    commit(types.CLEAR_LOCAL_CART_ITEMS)
  },
  enableSlotGrouping({commit}, payload) {
    commit(types.USE_SLOT_GROUPING, payload)
  },
  startHydratingData({commit}, payload) {
    commit(types.IS_HYDRATING_DATA, payload)
  },
  setProductAccessories({commit}, payload) {
    commit(types.SET_PRODUCT_ACCESSORIES, payload)
  },
  addRacerDetailsItem({commit}) {
    commit(types.ADD_RACER_DETAILS_ITEM)
  },
  updateRacerDetails({commit}, data) {
    commit(types.UPDATE_RACER_DETAILS_ITEM, data)
  },
  deleteRacerDetails({commit}, index) {
    commit(types.DELETE_RACER_DETAILS_ITEM, index)
  }
}

// getters
const getters = {
  // ...mapGetters(state.form),
  holdDefaults: state => holdDefault,
  productAccessories: state => state.productAccessories,
  updateAccessoriesCartItem(state, getters) {
    return function ({id, item, parentId}) {
      const items = {[item.id]: item}
      const cartItems = helpers.prepareAccessoriesCartItems(items, parentId, state.settings, state, getters)
      const newItem = _.first(_.values(cartItems))
      return newItem
    }
  },
  isHydratingData: state => state.isHydrating,
  isSlotGroupingEnabled: state => state.allowSlotGrouping,
  isUsingPackages: (state, getters) => getters.input('usePackages'),
  isRacingSeparately: (state, getters) => getters.input('raceSeparately') ==='yes',

  raceEditItem: state => state.editItem,
  isRaceInEditMode: state => !!state.editItem,
  input(state, getters) {
    return function (item) {
      if (!item) {
        return state.form
      }
      return state.form[item]
    }
  },
  settings(state, getters) {
    return function (item) {
      return state.settings[item]
    }
  },
  maxKarts: state => state.settings.maxKarts,

  retrievedTimeslot(state, getters) {
    return function (time) {
      return getters.retrievedTimeslots[time]
      // return getters.retrievedTimeslots.a[time] ||  getters.retrievedTimeslots.e[time]
    }
  },
  selectedAllTimeslots: state => state.form.selectedSlots || {},
  numberOfSelectedAllTimeslots: (state, getters) => Object.keys(getters.selectedAllTimeslots).length,
  selectedTimeslots(state, getters) {
    return _.filter(getters.selectedAllTimeslots, ({racers}) => racers > 0 )
  },
  getSelectedTimeslot(state, getters) {
    return function (time) {
      return getters.selectedAllTimeslots[time]
    }
  },

  totalPlayers(state, getters) {
    return parseNumber(state.form.numberOfAdults) + parseNumber(state.form.numberOfJuniors)
  },
  totalPlayersGrouped(state, getters) {
    return {[ADULTTYPE]: parseNumber(state.form.numberOfAdults), [JUNIORTYPE]: parseNumber(state.form.numberOfJuniors)}
  },
  totalRacersSlotted(state, getters) {
    return _.reduce(getters.selectedTimeslots, (total, {racers = 0}) => total + racers, 0)
  },
  totalRacersSlottedGrouped(state, getters) {
    return _.reduce(getters.selectedTimeslots, (carry, {type, racers = 0}) => {
        carry[type] += racers
        return carry
      }, {[JUNIORTYPE]: 0, [ADULTTYPE]: 0})
  },
  totalRacersNotSlottedGrouped(state, getters) {
    const slotted = getters.totalRacersSlottedGrouped
    return {
      junior: max(0, getters.maxAllowedJuniorRaces - slotted.junior),
      adult: max(0, getters.maxAllowedAdultRaces - slotted.adult),
    }
  },
  totalRacersNotSlotted(state, getters) {
    return max(0, getters.maxAllowedRaces - getters.totalRacersSlotted)
  },

  totalTMembersSlotted(state, getters) {
    return _.reduce(getters.selectedTimeslots, (total, {tMembers = 0}) => total + tMembers, 0)
  },
  totalTMemberPairSlotted(state, getters) {
    return _.reduce(getters.selectedTimeslots, (total, {racers = 0, tMembers = 0}) =>
      total + (tMembers >= racers ? 0 : tMembers)
    , 0)
  },
  totalTMemberDiscountedRaces(state, getters) {
    return getters.totalTMembersSlotted + getters.totalTMemberPairSlotted
  },
  totalMembersNotSlotted(state, getters) {
    return max(0, state.form.numberOfTitaniumRaces - getters.totalTMembersSlotted)
  },

  membersRegistered(state, getters) {
    return state.membersRegistered
  },
  membersToRegister(state, getters) {
    return parseNumber(state.form.numberOfMembers)
  },

  costOfMembership(state, getters) {
    return state.settings.memberships.annual.rate
  },
  totalCostOfMembership(state, getters) {
    return getters.membersToRegister * getters.costOfMembership
  },
  currentMaxSelectableRacesPerSlotForPackages(state, getters) {
      const matrix = state.form.racerRacesMatrix || []
      const noSetMatrix = matrix.filter(({filled}) => !filled)
      const highestItem = _.maxBy(noSetMatrix, ({max}) => max) || {}
      return highestItem.max || 0
  },
  currentMaxSelectableRacesPerSlotForPackagesGrouped(state, getters) {
      const groupMatrix = state.form.racerRacesMatrixGrouped || []
      const currentMax = _.mapValues(groupMatrix, matrix => {
        const noSetMatrix = matrix.filter(({filled}) => !filled)
        const highestItem = _.maxBy(noSetMatrix, ({max}) => max) || {}
        return highestItem.max || 0
      })
      return currentMax
  },

  maxAllowedJuniorRaces(state, getters) {
    return parseNumber(state.form.numberOfJuniorRaces)
  },
  maxAllowedAdultRaces(state, getters) {
    return parseNumber(state.form.numberOfAdultRaces)
  },
  maxAllowedRacesGrouped(state, getters) {
    return {
      [JUNIORTYPE]: getters.maxAllowedJuniorRaces,
      [ADULTTYPE]: getters.maxAllowedAdultRaces
    }
  },
  maxAllowedRaces(state, getters) {
    return getters.maxAllowedAdultRaces + getters.maxAllowedJuniorRaces
  },

  numberOfRaces: (state, getters) => Object.keys(getters.selectedTimeslots).length,

  numberOfNonTitaniumRacers(state, getters) {
    return max(0, getters.totalRacersSlotted - getters.totalTMemberDiscountedRaces)
  },

  breakupOfRaces(state, getters) {

    const type = 'races'
    const racerDetails = state.form.racerDetails || []

    const date = DateTime.fromISO(getters.input('selectedDate')).toISODate()
    const allPackages = state.settings.races
    const {titanium, ...raceDefs} = allPackages
    const packages = Object.keys(raceDefs).sort((a, b) => b - a)

    let allRaces = racerDetails.map(racer => {
      return helpers.packageRacer(racer, {packages, titanium, state, getters})
    })

    allRaces = helpers.mapTitaniumGuests(allRaces, racerDetails, packages)

    const raceItems =  _.reduce(_.keys(allPackages), (raceItems, raceName) => {
      _.forOwn(allRaces, racer => {
        if (racer[raceName]) {
          raceItems[raceName] = (raceItems[raceName] || 0) + racer[raceName]
        }
      })
      return raceItems
    }, {});

    const races = _.reduce(raceItems, (races, quantity, key) => {
      if (quantity) {
        races.push({key, type, quantity, date})
      }
      return races
    }, [])

    return races
  },
  breakupOfReservations(state, getters) {
    const slots = getters.selectedTimeslots
    if (slots) {
      const date = DateTime.fromISO(getters.input('selectedDate')).toISODate()
      const adults = parseNumber(state.form.numberOfAdults)
      const juniors = parseNumber(state.form.numberOfJuniors)
      const totalPlayers = getters.totalPlayers
      const numberOfMembers = getters.membersRegistered
      const numberOfTitaniumMembers = getters.numberOfTitaniumMembers
      const numberOfTitaniumRaces = getters.numberOfTitaniumRaces
      const numberOfTitaniumGuests = getters.numberOfTitaniumGuests
      const numberOfTitaniumGuestRaces = getters.numberOfTitaniumGuestRaces
      const membersToRegister = getters.membersToRegister
      const numberOfRaces = getters.numberOfRaces
      const info = {
        adults,
        juniors,
        numberOfMembers,
        numberOfTitaniumMembers,
        numberOfTitaniumRaces,
        numberOfTitaniumGuests,
        numberOfTitaniumGuestRaces,
        membersToRegister,
        numberOfRaces,
        date
      }

      const reservations = _.reduce(slots, (reservations, slot) => {
        const meta = {type: slot.type, time: slot.time, racers: slot.racers, info}
        const bookingItem = slot.item
        const product_id = bookingItem.product_id
        const id = bookingItem.originalProductId
        const racers = 1 * slot.racers
        if (racers > 0) {
          if (!reservations[product_id]) {
            reservations[product_id] = {
              product_id, key: id, type: raceType, total: 0, tax_amount: 0, title: '', rate: 0, quantity: parseNumber(slot.racers)
            }
          } else {
            reservations[product_id].quantity += slot.racers
          }

          reservations[product_id].meta = meta
          reservations[product_id].meta.slots = slots
        }

        return reservations
      }, {})

      return Object.values(reservations)
    }

    return []
  },
  breakupOfAccessories(state, getters) {
    const items = getters.productAccessories || {}
    const accessories = _.reduce(items, (carry, item) => {
      const {id: key, product, count: quantity, type = 'accessories'} = item
      const {product_id, title, tax_amount = 0, rate = 0} = product
      if (quantity) {
        if (!carry[product_id]) {
          const total = rate * quantity
          carry[product_id] = {
            product_id, key, total, tax_amount, title, rate, quantity, type
          }
        } else {
          carry[product_id].total += (quantity * rate)
          carry[product_id].quantity += quantity
        }
      }
      return carry
    }, {})
    return Object.values(accessories)
  },
  totalCostOfRaces(state, getters) {
    return getters.proposedRaces.reduce((total, {amount = 0}) => total + amount, 0)
  },
  proposedMemberships(state, getters) {
    return helpers.getCartItem([{
          key: 'annual',
          type: 'memberships',
          quantity: getters.membersToRegister,
      }], {}, state.settings, state, getters)
  },
  proposedReservations(state, getters) {
    return helpers.getCartItem(getters.breakupOfReservations, {
      rate: 0, amount: 0
    }, state.settings, state, getters)
  },
  proposedRaces(state, getters) {
    return helpers.getCartItem(getters.breakupOfRaces, {}, state.settings, state, getters)
  },
  proposedAccessories(state, getters) {
    return helpers.getCartItem(getters.breakupOfAccessories, {}, state.settings, state, getters)
  },
  proposedCartItems(state, getters) {
    return [
      ...getters.proposedReservations,
      ...getters.proposedRaces,
      ...getters.proposedMemberships,
      ...getters.proposedAccessories,
    ]
  },
  proposedCart(state, getters) {
    return helpers.prepareUniversalCartItems(getters.proposedCartItems, state.settings, state, getters)
  },

  cartTotal(state, getters) {
    return getters.proposedCartItems.reduce((total, {amount = 0}) => total + amount, 0)
  },

  retrievedTimeslots : state => state.retrievedSlots,
  isRetrievingTimeslots: state => state.fetchingTimeslots,

  localRacesCartItems: state => state.cartItems,
}

// plugins
const plugins = []
// const plugins = [createPersistedState({
//     key: 'racewaybooking-shop',
//     subscriber: () => {
//       console.log(this.proposedCart)g(arguments)
//     }
// })]

const race = {namespaced, namespace, state, mutations, actions, getters, plugins}
export default race
